module.exports = {
    SET_CADASTROS: "SET_CADASTROS",
    SET_CONFIGURACOES: "SET_CONFIGURACOES",
    SET_MOVIMENTACAO: "SET_MOVIMENTACAO",
    SET_FINANCEIRO: "SET_FINANCEIRO",
    SET_FISCAL: "SET_FISCAL",
    SET_RELATORIOL: "SET_RELATORIOL",
    SET_SEGURANCA: "SET_SEGURANCA",
    SET_SALES: "SET_SALES",
}